<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('nav.invoice') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.revenue') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('nav.invoice') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid">
      <!-- /row -->
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-right">
                
              </div>
              <el-input :placeholder="$t('staff.search-ph')" v-model="keyword" class="input-with-select" style="width:300px">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="card-body">
              <el-table
                :data="mData"
                style="width: 100%"
                @cell-click="openDetail"
                >
                <el-table-column
                  prop="le"
                  :label="$t('offer.invoice.le')"
                  width="350"
                >
                </el-table-column>
                <el-table-column :label="$t('offer.invoice.invoice-value')">
                  <el-table-column
                    prop="invoiceValue"
                    :label="$t('offer.invoice.past-12')"
                    width="130">
                  </el-table-column>
                  <el-table-column
                    prop="comingInvoiceValue"
                    :label="$t('offer.invoice.coming-3')"
                    width="130"
                    >
                </el-table-column>
                </el-table-column>
                <el-table-column :label="$t('offer.invoice.cashin')">
                  <el-table-column
                    prop="cashIn"
                    :label="$t('offer.invoice.past-12')"
                    width="130"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="comingCashIn"
                    :label="$t('offer.invoice.coming-3')"
                    >
                  </el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <el-dialog :title="$t('offer.invoice.title1')" 
      :visible.sync="showDetail"
      width="70%"
      top="30px"
      :append-to-body="true"
      :close-on-click-modal="false">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('offer.invoice.past-12')" name="1">
                <el-timeline>
              <el-timeline-item
                v-for="(invoice, index) in detail.done"
                :key="index"
                :timestamp="invoice.invoiceDate"
                >
                <el-link :href="BASE_URL + '/#/invoice/edit/' + invoice.paymentId" target="_blank">{{ invoice.paymentName }} | {{ invoice.item }} | {{ invoice.invoiceTitle }} | {{ invoice.offerOwner }}</el-link>
              </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
        <el-tab-pane :label="$t('offer.invoice.coming-3')" name="2">
          <el-timeline>
              <el-timeline-item
                v-for="(invoice, index) in detail.tobe"
                :key="index"
                :timestamp="invoice.payDate"
                >
                <el-link :href="BASE_URL + '/#/offer/' + invoice.offerId" target="_blank">{{ invoice.vacancy }} | {{ invoice.value }}</el-link>
              </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
      </el-tabs>
            <div slot="footer" class="dialog-footer">
          <el-button @click="showDetail = false">{{ $t('offer.invoice.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'Invoice-List',
  components: {
  },
  data: function() {
  return {
    mData: null,
    keyword: null,
    detail: {
      'done': [],
      'tobe': []
    },
    showDetail: false,
    activeName: '1'
  }
  },
  computed: {
    
  },
  methods: {
    openOffer: function(offerId) {
      window.open(this.BASE_URL + '/#/offer/' + offerId)
    },
    openInvoice: function(paymentId) {
      window.open(this.BASE_URL + '/#/invoice/' + paymentId)
    },
    openDetail: function(row, column, cell, event) {
      let sd = moment(new Date()).subtract(1, 'years').format('YYYY-MM-DD'),
          ed = moment(new Date()).format('YYYY-MM-DD'),
          le = row.id
      this.loadDetail(sd, ed, le)
      this.showDetail = true
    },
    loadDetail: function(sd, ed, le) {
        let that = this,
            userId = localStorage.getItem('token'),
            query = 'userId=' + userId + '&startDate=' + sd + '&endDate=' + ed + '&legalEntity=' + le
        this.$http.get(this.API3_PREFIX + 'invoices?' + query).then(function (response) {
      that.detail = response.data
    }).catch(function (error) {
      console.log(error)
    })
    },
    loadData: function() {
      let that = this
      /*that.legalEntity.forEach(function(v, i) {
        that.mData[v['id']] = {
          'id': v['id'],
          'le': that.$i18n.locale === 'zh' ? v['c_name'] : v['e_name'],
          'invoiceValue': 0.0,
          'comingInvoiceValue': 0.0,
          'cashIn': 0.0,
          'comingCashIn': 0.0
        }
      })*/

    this.$http.get(this.API3_PREFIX + 'invoice_management').then(function (response) {
    let d = response.data,
        tmp = []
    that.legalEntity.forEach(function(v, i) {
          tmp[v['id']] = {
            'id': v['id'],
            'le': that.$i18n.locale === 'zh' ? v['c_name'] : v['e_name'],
            'invoiceValue': 0.0,
            'comingInvoiceValue': 0.0,
            'cashIn': 0.0,
            'comingCashIn': 0.0
          }
        })
    d['invoice_value'].forEach(function(v, i) {
          if (that.getLegalEntity(i)) {
            //that.mData[i]['invoiceValue'] = v
            that.$set(tmp[i], 'invoiceValue', v)
          }
    })
    d['coming_invoice_value'].forEach(function(v, i) {
          if (that.getLegalEntity(i)) {
            //that.mData[i]['comingInvoiceValue'] = v
            that.$set(tmp[i], 'comingInvoiceValue', v)
          }
    })
    d['cash_in'].forEach(function(v, i) {
          if (that.getLegalEntity(i)) {
            //that.mData[i]['cashIn'] = v
            that.$set(tmp[i], 'cashIn', v)
          }
    })
    d['coming_cash_in'].forEach(function(v, i) {
          if (that.getLegalEntity(i)) {
            that.$set(tmp[i], 'comingCashIn', v)
          }
    })
    //console.log(that.mData)

    that.mData = tmp
      }).catch(function (error) {
    console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>